import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'

const getRoleDataAccesses = async (token, params) => {
  const url = `roles/${params.role_id}/data_access`
  const data = await apiGet({ url, params, token })
  return data
}

export function useRoleDataAccesses({ params, options }) {
  const token = useContext(AuthContext)
  const queryFn = () => getRoleDataAccesses(token, params)
  const queryKey = ['role-data-access', params]
  return useQuery(queryKey, queryFn, { ...options })
}
